import { buttonTheme } from "./components/button";
import { calloutTheme } from "./components/callout";
import { containerTheme } from "./components/container";
import { headingTheme } from "./components/heading";
import { labelTheme } from "./components/label";
import { textTheme } from "./components/text";

export const theme = {
  button: buttonTheme,
  callout: calloutTheme,
  container: containerTheme,
  heading: headingTheme,
  label: labelTheme,
  text: textTheme,
};
